import { getSeedRandomColor } from "@pathwright/utils/src/color/color-utils"
import { AvatarUser } from "./types"

export function getAvatarInitials(user: AvatarUser) {
  const firstInitial = (user.first_name || "?").slice(0, 1)[0]
  const lastInitial = (user.last_name || "?").slice(0, 1)[0]
  return `${firstInitial}${lastInitial}`.toUpperCase()
}

export function getAvatarFallbackBG(user: AvatarUser) {
  const initials = getAvatarInitials(user)
  const seed = user?.id || initials?.toLowerCase() || "?"
  // NOTE: legacy ui code passes seed as number which results in different colors.
  // In order to unify avatar colors across the app we cast to string.
  return getSeedRandomColor(seed as string)
}

// Avoid using the default profile image.
export function getImage(user: AvatarUser): string | undefined {
  const image = user.profile?.image
  return (image?.indexOf("profile-default") || 0) === -1 ? image! : undefined
}
